module.exports = __webpack_public_path__ + "assets/img/one-tab10-on.cb4ca8e8.png";